import axios from ".";

const _ = (url) => `/locations/${url}`;

const locations = {
  getStates: () => axios.get(_("states")),
  getLgas: (stateId) => axios.get(_(`states/${stateId}/lgas`)),
};

export default locations;
